import { RunHistory } from "@/features/oversight/reconciliation";

export default function ReconciliationRunHistoryPage() {
  return <RunHistory />;
}